var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "courseEditDialog",
      attrs: {
        modal: true,
        "modal-append-to-body": true,
        title: _vm.title,
        visible: _vm.show,
        "close-on-click-modal": false,
        "show-close": true,
        "close-on-press-escape": true,
        "before-close": _vm.clickCancel,
        width: "832px"
      },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "courseForm",
          attrs: { model: _vm.courseForm, rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "courseName",
              attrs: { label: "课程名称", prop: "courseName" }
            },
            [
              _c("el-input", {
                attrs: {
                  autocomplete: "off",
                  placeholder: "请输入课程名称",
                  maxlength: "50"
                },
                model: {
                  value: _vm.courseForm.courseName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.courseForm,
                      "courseName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "courseForm.courseName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "courseIntroduction",
              attrs: { label: "课程简介", prop: "courseIntroduction" }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "限150字",
                  maxLength: "150"
                },
                model: {
                  value: _vm.courseForm.courseIntroduction,
                  callback: function($$v) {
                    _vm.$set(_vm.courseForm, "courseIntroduction", $$v)
                  },
                  expression: "courseForm.courseIntroduction"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              style:
                _vm.productFlag == 2 ||
                _vm.productFlag == 3 ||
                _vm.productFlag == 4 ||
                _vm.productFlag == 7
                  ? "display:flex"
                  : ""
            },
            [
              _c(
                "div",
                { staticClass: "subject_classHour" },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "subject",
                      attrs: { label: "专业科目", prop: "subject" }
                    },
                    [
                      _vm.subjectList.length > 0
                        ? _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择所属专业科目",
                                disabled: _vm.isChangeSubject
                              },
                              on: { change: _vm.change },
                              model: {
                                value: _vm.courseForm.subject,
                                callback: function($$v) {
                                  _vm.$set(_vm.courseForm, "subject", $$v)
                                },
                                expression: "courseForm.subject"
                              }
                            },
                            _vm._l(_vm.subjectList, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.name,
                                  title: item.name,
                                  value: item.id
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "classHour",
                      attrs: { label: "课时", prop: "classHour" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入课时数",
                          maxlength: "5",
                          oninput: "value=value.replace(/[^\\d]/g,'')"
                        },
                        model: {
                          value: _vm.courseForm.classHour,
                          callback: function($$v) {
                            _vm.$set(_vm.courseForm, "classHour", $$v)
                          },
                          expression: "courseForm.classHour"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.productFlag == 2 ||
              _vm.productFlag == 3 ||
              _vm.productFlag == 4 ||
              _vm.productFlag == 7
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "post",
                          attrs: { label: "选择岗位", prop: "post" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                multiple: "",
                                placeholder: "请选择岗位"
                              },
                              model: {
                                value: _vm.courseForm.post,
                                callback: function($$v) {
                                  _vm.$set(_vm.courseForm, "post", $$v)
                                },
                                expression: "courseForm.post"
                              }
                            },
                            _vm._l(_vm.postList, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.productFlag != 7
            ? _c(
                "el-form-item",
                {
                  staticClass: "subject",
                  attrs: { label: "课程类型", prop: "isPay" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.courseForm.isPay,
                        callback: function($$v) {
                          _vm.$set(_vm.courseForm, "isPay", $$v)
                        },
                        expression: "courseForm.isPay"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "标准", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "免费", value: 0 } })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "60%" },
              attrs: { label: "封面", prop: "coursePic" }
            },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    data: _vm.uploadData,
                    disabled: _vm.isDisabled,
                    action: _vm.uploadSrc,
                    headers: _vm.headers,
                    accept: ".jpg,.png,.jpeg",
                    "show-file-list": false,
                    "on-progress": _vm.handleAvatarProgress,
                    "on-success": _vm.handleAvatarSuccess,
                    "before-upload": _vm.beforeAvatarUpload
                  },
                  model: {
                    value: _vm.pic,
                    callback: function($$v) {
                      _vm.pic = $$v
                    },
                    expression: "pic"
                  }
                },
                [
                  _vm.pic
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.pic }
                      })
                    : _c("i", { class: _vm.uploadIcon })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.productFlag == 2 ||
          _vm.productFlag == 3 ||
          _vm.productFlag == 4 ||
          _vm.productFlag == 7
            ? _c("div", { staticClass: "tips" }, [
                _c("p", [_vm._v("* 提示：课程创建后不可修改科目和岗位。")])
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.clickCancel } }, [_vm._v("取消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitForm("courseForm")
                }
              }
            },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8eccce64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8eccce64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/course/courseInfoDialog.vue
// module id = null
// module chunks = 